import { render } from "./MasterDetailDiklat.vue?vue&type=template&id=3e7f3b54"
import script from "./MasterDetailDiklat.vue?vue&type=script&lang=js"
export * from "./MasterDetailDiklat.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__